module.exports = __webpack_public_path__ + "static/media/victory_tracks.73787a03.png";